export enum ModelName {
  Customer = 'Customer',
  Creative = 'Creative',
  Outlet = 'Outlet',
  Product = 'Product',
  PodcastSpot = 'PodcastSpot',
  LegacySpot = 'LegacySpot',
}
